<template>
  <div class="page-main">
    <div class="join-page">
      <h2 class="join-page-title">加入企业</h2>
      <div class="join-page-form" style="font-size: 14px; text-align: center;">
        <div>公司中文名称：{{companyInfo.companyCNName}}</div>
        <div>公司英文名称：{{companyInfo.companyENName}}</div>
      </div>
      <div style="padding: 0 0 24px; text-align: center;">
        <Button type="primary" v-if="submiting" @click="joinCompany">正在加入...</Button>
        <Button type="primary" v-if="!submiting" @click="joinCompany">确定加入企业</Button>
      </div>
    </div>
  </div>
</template>

<script>
import { httpAjax } from "@/api/ajax";
import { Message } from 'view-design';
import { GetRequest } from '@/api/config';

const userData = JSON.parse(localStorage.getItem('userData'));

export default {
  name: "login",
  data() {
    return {
      companyInfo: {},
      submiting: false,
    };
  },
  created() {
    alert();
    this.getInfo();
  },
  mounted() {},
  methods: {

    // 获取数据
    getInfo() {
      this.loading = true;
      httpAjax({
        url: `/services/company/invite/${GetRequest().invite}/info`,
        method: "get",
        data: params,
      }).then((response) => {
        if (response.success) {
          this.companyInfo = response.data;
        } else {
          this.$message({
            message: response.msg,
            type: 'error'
          })
        }
        this.loading = false;
      });
    },

    joinCompany() {
      this.submiting = true;
      httpAjax({
        url: `/services/company/invite/${GetRequest().invite}/confirm`,
        method: "post",
      }).then((response) => {
        if (response.success) {
          this.$message({
            message: '加入企业成功',
            type: 'success'
          })
          this.$router.push({
            name: this.$indexPage,
          });
        } else {
          this.$message({
            message: response.msg,
            type: 'error'
          })
        }
        this.submiting = false;
      });
    },
  },
  watch: {},
  filters: {},
};
</script>

<style lang="less">
  .join-page {
    background: #fff;
    width: 600px;
    
    margin: 50px auto;
    border-radius: 6px;
    box-shadow: 0 5px 5px rgba(0, 0, 0, .05);

    .join-page-title {
      text-align: center;
      padding: 18px 0;
      border-bottom: 1px solid #e6e6e6;
    }

    .join-page-form {
      padding: 24px;
    }
  }
</style>
